import { CENTER } from "./constants";

/**
 * Converts polar coords to SVG cartesian.
 * angleDeg=0 → bottom of field (bowler end / straight direction)
 * angleDeg increases clockwise → off side (left in diagram)
 * The +90 offset makes 0deg point downward in SVG space.
 */
export function polarToCartesian(angleDeg, radius) {
  const angleRad = (angleDeg + 90) * (Math.PI / 180);
  return {
    x: CENTER.x + radius * Math.cos(angleRad),
    y: CENTER.y + radius * Math.sin(angleRad),
  };
}

export function describeWedgePath(
  startAngle,
  endAngle,
  innerRadius,
  outerRadius,
) {
  const startOuter = polarToCartesian(startAngle, outerRadius);
  const endOuter = polarToCartesian(endAngle, outerRadius);
  const startInner = polarToCartesian(endAngle, innerRadius);
  const endInner = polarToCartesian(startAngle, innerRadius);

  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  if (innerRadius === 0) {
    // Pie slice from center
    return [
      `M ${CENTER.x} ${CENTER.y}`,
      `L ${startOuter.x} ${startOuter.y}`,
      `A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${endOuter.x} ${endOuter.y}`,
      "Z",
    ].join(" ");
  }

  return [
    `M ${startOuter.x} ${startOuter.y}`,
    `A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${endOuter.x} ${endOuter.y}`,
    `L ${startInner.x} ${startInner.y}`,
    `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${endInner.x} ${endInner.y}`,
    "Z",
  ].join(" ");
}
